var map = {
	"./cursors/arrow_left": 12,
	"./cursors/arrow_left.svg": 12,
	"./cursors/arrow_left@1x": 13,
	"./cursors/arrow_left@1x.png": 13,
	"./cursors/arrow_left@2x": 14,
	"./cursors/arrow_left@2x.png": 14,
	"./cursors/arrow_right": 15,
	"./cursors/arrow_right.svg": 15,
	"./cursors/arrow_right@1x": 16,
	"./cursors/arrow_right@1x.png": 16,
	"./cursors/arrow_right@2x": 17,
	"./cursors/arrow_right@2x.png": 17,
	"./favicon": 18,
	"./favicon.svg": 18,
	"./invoice_logo": 19,
	"./invoice_logo.svg": 19,
	"./tshirt": 20,
	"./tshirt.svg": 20,
	"./yellow_dot": 21,
	"./yellow_dot.svg": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;